import React from "react";
import { Link } from "react-router-dom";
import { footer } from "../mock";
import { Mail, Phone, Facebook, Instagram, Twitter } from "lucide-react";

const browseTo = {
  "Strength Training": "/collection/strength-training",
  "Cardio": "/collection/cardio-machines",
  "Package Deals": "/collection/package-deals",
  "Functional Training": "/collection/functional-training",
  "Flooring & Mirrors": "/collection/gym-flooring",
  "Boxing & MMA Gear": "/collection/weight-sets",
  "Accessories": "/collection/weight-sets",
};
const customerTo = {
  "Contact Us": "/pages/contact",
  "Gym Fitouts": "/pages/gym-fitouts",
  "Shipping & Returns": "/pages/shipping-returns",
  "Terms of Use": "/pages/terms",
  "Privacy Policy": "/pages/privacy",
  "My Account": "/pages/contact",
  "Our Brands": "/pages/brands",
};

export default function Footer() {
  return (
    <footer className="bg-navy text-white">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 md:grid-cols-2 lg:grid-cols-4 lg:px-8">
        <div>
          <span className="font-heading text-2xl font-extrabold">
            CYBER<span className="text-brand">FIT</span>
          </span>
          <h4 className="mt-5 text-xs font-bold uppercase tracking-widest text-white/50">Store & Showroom</h4>
          <div className="mt-2 space-y-0.5 text-sm text-white/70">
            {footer.address.map((l) => (
              <p key={l}>{l}</p>
            ))}
          </div>
          <h4 className="mt-5 text-xs font-bold uppercase tracking-widest text-white/50">Open Times</h4>
          <div className="mt-2 space-y-0.5 text-sm text-white/70">
            {footer.openTimes.map((l) => (
              <p key={l}>{l}</p>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-xs font-bold uppercase tracking-widest text-white/50">Browse</h4>
          <ul className="mt-3 space-y-2">
            {footer.browse.map((l) => (
              <li key={l}>
                <Link to={browseTo[l] || "/collection/weight-sets"} className="text-sm text-white/70 transition-colors hover:text-brand">{l}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs font-bold uppercase tracking-widest text-white/50">Customer Information</h4>
          <ul className="mt-3 space-y-2">
            {footer.customer.map((l) => (
              <li key={l}>
                <Link to={customerTo[l] || "/pages/contact"} className="text-sm text-white/70 transition-colors hover:text-brand">{l}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs font-bold uppercase tracking-widest text-white/50">Contact</h4>
          <div className="mt-3 space-y-2 text-sm text-white/70">
            <a href={`mailto:${footer.contact.email}`} className="flex items-center gap-2 hover:text-brand">
              <Mail size={16} /> {footer.contact.email}
            </a>
            <a href="tel:+61296206635" className="flex items-center gap-2 hover:text-brand">
              <Phone size={16} /> {footer.contact.phone}
            </a>
          </div>
          <h4 className="mt-5 text-xs font-bold uppercase tracking-widest text-white/50">Follow Us</h4>
          <div className="mt-3 flex gap-3">
            {[Facebook, Instagram, Twitter].map((Icon, i) => (
              <a key={i} href="#" className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-white transition-colors hover:bg-brand" aria-label="Social">
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-4 py-5 text-xs text-white/50 lg:px-8">
          Copyright &copy; {new Date().getFullYear()} Cyberfit. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
